import React from "react"
import { AppBulkEditAction } from "@components"

import { useUserSettingsCategory, useUserSettingsCategoryValidator } from "../../../@hooks"


export default function UserSettingCategoryDrawerSubmit() {
	const { isLoading, handleSubmitCategoryFormData } = useUserSettingsCategory()
	const { isValid } = useUserSettingsCategoryValidator()

	return <AppBulkEditAction
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitCategoryFormData}
	>
		Save
	</AppBulkEditAction>
}